var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"w-6 h-6 text-gray-800 dark:text-white",attrs:{"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M5 12h14M5 12l4-4m-4 4 4 4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }